var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermissions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6V8H9V10H7V8H5.8C5.4 9.2 4.3 10 3 10C1.3 10 0 8.7 0 7C0 5.3 1.3 4 3 4C4.3 4 5.4 4.8 5.8 6H11ZM3 6C2.4 6 2 6.4 2 7C2 7.6 2.4 8 3 8C3.6 8 4 7.6 4 7C4 6.4 3.6 6 3 6ZM16 10C18.7 10 24 11.3 24 14V16H8V14C8 11.3 13.3 10 16 10ZM16 8C13.8 8 12 6.2 12 4C12 1.8 13.8 0 16 0C18.2 0 20 1.8 20 4C20 6.2 18.2 8 16 8Z",
    fill: "var(--primary-color-text)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissions);
export default __webpack_public_path__ + "static/media/permissions.e6452c098132d895bdb95271ba04aa2a.svg";
export { ForwardRef as ReactComponent };